<script setup>
import { RouterView, useRoute } from 'vue-router';
import { computed, onMounted } from 'vue';
import { useSessionStore } from './stores/core/session';
import logger from './utils/logger';
import LogoSvg from '@/assets/logo.svg?url';

const route = useRoute();
const sessionStore = useSessionStore();

// Show navigation only on routes that require it
const showNavigation = computed(() => {
	return route.meta.requiresNavigation === true;
});

onMounted(async () => {
	logger.debug('App mounted');

	// ✅ Initialize session FIRST before any other API calls
	// This ensures CSRF token is available for tracking, analytics, etc.
	try {
		//TODO: we need to make sure its non blocking, we need a proper aproach for it
		await sessionStore.initializeSession();
		logger.debug('Session initialized successfully');
	} catch (error) {
		logger.error('Failed to initialize session', { error });
	}
});
</script>

<template>
	<div class="min-h-screen">
		<!-- Navigation only shown on wizard and results pages -->
		<nav
			v-if="showNavigation"
			class="sticky top-0 z-50 bg-white border-b border-gray-200 shadow-sm"
		>
			<div class="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
				<div class="flex justify-between h-14 sm:h-16">
					<div class="flex items-center">
						<!-- Logo/Brand - Clickable link to home -->
						<router-link
							to="/"
							class="flex items-center gap-2 px-2 -ml-2 text-lg font-bold text-blue-600 transition-colors duration-200 rounded-lg sm:text-2xl hover:text-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
							title="Zur Startseite"
							aria-label="LernTypen Test - Zur Startseite"
						>
							<img :src="LogoSvg" alt="Schule Leichter Logo" class="w-35" />
						</router-link>
					</div>
				</div>
			</div>
		</nav>

		<!-- Main content area -->
		<main :class="showNavigation ? 'max-w-7xl mx-auto py-6 sm:px-6 lg:px-8' : ''">
			<RouterView />
		</main>
	</div>
</template>

<style scoped></style>
